"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryBoxInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const MysteryBoxInput = () => {
    const contractId = (0, react_hook_form_1.useWatch)({ name: "contractId" });
    const mysteryId = (0, react_hook_form_1.useWatch)({ name: "mysteryId" });
    const form = (0, react_hook_form_1.useFormContext)();
    const handleChange = (_event, option) => {
        form.setValue("mysteryBox", option, { shouldDirty: true });
        form.setValue("mysteryId", option?.id ?? 0, { shouldDirty: true });
    };
    (0, react_1.useEffect)(() => {
        if (!mysteryId) {
            form.setValue("mysteryBox", null);
        }
    }, [mysteryId]);
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { required: true, name: "mysteryId", controller: "mystery/boxes", onChange: handleChange, fetchData: { contractIds: [contractId] }, autoSelect: true, disableClear: true }));
};
exports.MysteryBoxInput = MysteryBoxInput;
//# sourceMappingURL=index.js.map